import React, { useEffect, useState } from "react";
import styles from "./MainCarousel.module.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { socialMediaLink } from "../../utilities/settings";
import { Col, Row } from "reactstrap";
import Clock from "./Clock";

export interface IMainCarousel {
    bannerId: number,
    bannerName: string,
    webImageURL: string,
    mobileImageURL: string,
    thumbnailURL: string,
    onClickLink: string,
    isExternalLink: boolean
    title: string,
    timerHeader: string,
    expireTime: string,
    timerIsActive: boolean,
    timerStatus: boolean 
}
interface PropsType {
    mainCarousel: IMainCarousel[],
}



export default function MainCarousel(props: PropsType) {
    var webView = true;
    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const [isSlideChange, setIsSlideChange] = useState<boolean>(true);

    var slideIndex = 1;
    var thumbnailIndex = 2;

    let intervalID: any;
    useEffect(
        () => {
            // console.log(props.mainCarousel)
            if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
                webView = false;
                setIsWeb(false);
            }
            else { webView = true }
            if (isSlideChange) {
                intervalID = window.setInterval(() => plusSlides(1), 5000)
            }
            return () => clearInterval(intervalID);
        },

        [isSlideChange]
    );

    function plusSlides(n: any) {
        showSlides(slideIndex += n);
        if (webView && isWeb) {
            thumbnail(thumbnailIndex += n);
        }
    }

    function showSlides(n: any) {
        var i;
        var offer;
        var timer;
        var slides = document.getElementsByClassName(`${styles.mySlides}`);
        var dot = document.getElementsByClassName(`${styles.dot}`);
        if(webView && isWeb){
            offer = document.getElementsByClassName(`${styles.special_offer_div}`)
            timer = document.getElementsByClassName(`${styles.countDownTimer_div}`)
        }else{
            offer = document.getElementsByClassName(`${styles.special_offer_div_mobile}`)
            timer = document.getElementsByClassName(`${styles.countDownTimer_div_mobile}`)
        }
        if (n > slides.length) { slideIndex = 1 }
        if (n < 1) { slideIndex = slides.length }
        for (i = 0; i < slides.length; i++) {
            (slides[i] as HTMLElement).style.display = "none";
            (dot[i] as HTMLElement).style.backgroundColor = "#bbb";
            (offer[i] as HTMLElement).style.display = "none";
            (timer[i] as HTMLElement).style.display = "none";
        }
        (slides[slideIndex - 1] as HTMLElement).style.display = "block";
        (dot[slideIndex - 1] as HTMLElement).style.backgroundColor = "white";
        (offer[slideIndex - 1] as HTMLElement).style.display = "block";
        (timer[slideIndex - 1] as HTMLElement).style.display = "block";
    }

    function thumbnail(n: any) {
        var i;
        var thumbnail = document.getElementsByClassName(`${styles.nextSlide}`);
        if (n < 1) { thumbnailIndex = thumbnail.length }
        if (n > thumbnail.length) { thumbnailIndex = 1 }
        // if (n == 2) { thumbnailIndex = 3 }
        for (i = 0; i < thumbnail.length; i++) {
            (thumbnail[i] as HTMLElement).style.display = "none";
        }
        (thumbnail[thumbnailIndex - 1] as HTMLElement).style.display = "block";
    }

    function dotClick(id: number) {
        showSlides(slideIndex = id + 1);
        if (webView && isWeb) {
            thumbnail(thumbnailIndex = id + 2);
        }
    }

    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <div className={`${styles.slideshowContainer}`} onMouseEnter={() => setIsSlideChange(false)} onMouseLeave={() => setIsSlideChange(true)}>

                    {isWeb ?
                        <>
                            {props.mainCarousel.map((item, index) => {
                                return (
                                    <>
                                        <div key={item.bannerId} className={`${styles.mySlides} ${styles.fade}`} style={{ display: index == 0 ? "block" : "none", cursor: "pointer" }}>
                                            <img onClick={() => item.isExternalLink ? window.open(item.onClickLink, '_blank') : (window.location.href = item.onClickLink)}
                                                src={item.webImageURL}
                                                style={{ width: '100%' }} />
                                        </div>
                                        {                                            
                                            <div key={item.bannerId} className={`${styles.special_offer_div}`} 
                                            style={{ display: index == 0 ? "block" : "none", cursor: "pointer", backgroundColor : item.timerStatus ? "#182b66" : "" }}>                                                                     
                                                <Row>
                                                    <Col md="8" lg="8">
                                                        <p className={`${styles.special_offer_font}`}>{item.timerStatus ? item.title : ""}</p>
                                                    </Col>
                                                    <Col md="4" lg="4">
                                                        <div className={`${styles.countDownTimer_div}`} style={{ border : item.timerStatus ? "3px solid cyan" : "" }}>
                                                            <Row>
                                                                <Row>
                                                                    <p className={`${styles.countDownTimer_offer_font}`}>{item.timerStatus ? item.timerHeader : ""}</p>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                    {
                                                                        item.timerStatus ? 
                                                                        <Clock deadLineDate={item.expireTime} isWebStatus={isWeb}/>
                                                                        : null
                                                                    }   
                                                                    </Col>
                                                                </Row>                                        
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>                                 
                                            </div>                                            
                                        }                                        
                                    </>
                                );
                            })}
                            {props.mainCarousel.map((item, index) => {
                                return (
                                    <div key={item.bannerId} className={`${styles.nextSlide} ${styles.fade}`} style={{ display: index == 1 ? "block" : "none" }}>
                                        <img src={item.thumbnailURL} style={{ height: "150px" }} />
                                    </div>
                                );
                            })}
                            <div className={`${styles.navBG}`}>
                                <a className={`${styles.prev}`} onClick={() => plusSlides(-1)}>&#8592;</a>
                                <a className={`${styles.next}`} onClick={() => plusSlides(1)}>&#8594;</a>
                            </div>                            
                        </>
                        :
                        <>
                            {props.mainCarousel.map((item, index) => {
                                return (
                                    <>
                                        <div key={item.bannerId} className={`${styles.mySlides} ${styles.fade}`} style={{ display: index == 0 ? "block" : "none" }}>
                                            <img  onClick={() => window.open(item.onClickLink)}    src={item.mobileImageURL}  style={{ width: '100%' }} />
                                        </div>
                                        <div key={item.bannerId} className={`${styles.special_offer_div_mobile}`} 
                                        style={{ display: index == 0 ? "block" : "none", cursor: "pointer", backgroundColor : item.timerStatus ? "#182b66" : "" }}> 
                                            <Row>
                                                <Col md="8" lg="8">
                                                    <p className={`${styles.special_offer_font_mobile}`}>{item.timerStatus ? item.title : ""}</p>
                                                </Col>
                                                <Col md="4" lg="4">
                                                    <div className={`${styles.countDownTimer_div_mobile}`} style={{ border : item.timerStatus ? "2px solid cyan" : "" }}>
                                                        <Row>
                                                            <Row>
                                                                <p className={`${styles.countDownTimer_offer_font_mobile}`}>{item.timerStatus ? item.timerHeader : ""}</p>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    {
                                                                        item.timerStatus ? 
                                                                        <Clock deadLineDate={item.expireTime} isWebStatus={isWeb}/>
                                                                        : null
                                                                    }                                                                    
                                                                </Col>
                                                            </Row>                                        
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>   
                                        </div>
                                    </>                                    
                                );
                            })}
                            <a className={`${styles.prev}`} style={{ bottom: "50%", left: 0, color: "white" }} onClick={() => plusSlides(-1)}>&#10094;</a>
                            <a className={`${styles.next}`} style={{ bottom: "50%", left: "87%", color: "white" }} onClick={() => plusSlides(1)}>&#10095;</a>                            
                        </>
                    }

                    <div className={`${styles.dotDiv}`}>
                        {props.mainCarousel.map((item, index) => {
                            return (
                                <span key={index} className={`${styles.dot}`} style={{ backgroundColor: index == 0 ? "white" : "#bbb" }}
                                    onClick={() => dotClick(index)} ></span>
                                // style={{ backgroundColor: index == (slideIndex) ? "white" : "#bbb" }}
                            )
                        })
                        }
                    </div>
                    {isWeb ?
                        <div className={`${styles.linksContainer}`} >
                            <div className={`${styles.verticaltext}`}>
                                <span className={`${styles.links}`} onClick={() => window.open(socialMediaLink.facebook, '_blank')}>FACEBOOK</span>
                                <span>  |  </span>
                                <span className={`${styles.links}`} onClick={() => window.open(socialMediaLink.linkedin, '_blank')}>LINKEDIN</span>
                                <span>  |  </span>
                                <span className={`${styles.links}`} onClick={() => window.open(socialMediaLink.instagram, '_blank')}>INSTAGRAM</span>
                            </div>
                            <div className={`${styles.verticalLine}`} hidden></div>
                        </div>
                        : null}
                </div>
                <br />
            </div>
        </React.Fragment >
    )
}